import React from 'react';
import { Box, Chip, Stack } from '@mui/material';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import dayjs from 'dayjs';
import { EVENT_TYP_LABEL, EQP_STATE_LABEL, describeEventDetail } from './eqpState';

const TYP_OPTIONS = [
  { value: '', label: '전체' },
  { value: 'STATE', label: '상태' },
  { value: 'ALARM', label: '알람' },
  { value: 'PROGRAM', label: '프로그램' },
  { value: 'ONLINE', label: '통신' },
];

// STATE 는 운전/정지 같은 한글 라벨, 나머지(알람코드·프로그램 번호)는 값 그대로
const ONOFF_LABEL = { ALARM: { ON: '발생', OFF: '해제' }, ONLINE: { ON: '연결', OFF: '끊김' } };
const valLabel = (row) => {
  if (row.typ === 'STATE') return EQP_STATE_LABEL[row.val] || row.val;
  return (ONOFF_LABEL[row.typ] && ONOFF_LABEL[row.typ][row.val]) || row.val;
};

const durationLabel = (sec) => {
  if (sec === null || sec === undefined) return '진행중';
  const s = Math.max(0, Math.round(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  if (h > 0) return `${h}시간 ${m}분`;
  if (m > 0) return `${m}분 ${ss}초`;
  return `${ss}초`;
};

// 종류 필터 칩 + 이벤트 표(시각/종류/값/지속시간/상세) + 서버 페이지네이션
const EqpEventListPanel = ({ list, total, loading, typFilter, onTypFilterChange, page, pageSize, onPageChange }) => {
  const columns = [
    {
      field: 'stDt', headerName: '시각', width: 150,
      renderCell: ({ value }) => (value ? dayjs(value).format('MM-DD HH:mm:ss') : '-'),
    },
    {
      field: 'typ', headerName: '종류', width: 90,
      renderCell: ({ value }) => <Chip size="small" label={EVENT_TYP_LABEL[value] || value} />,
    },
    {
      field: 'val', headerName: '값', width: 130,
      renderCell: ({ row }) => valLabel(row),
    },
    {
      field: 'durationSec', headerName: '지속시간', width: 110,
      renderCell: ({ value }) => durationLabel(value),
    },
    {
      field: 'detail', headerName: '상세', flex: 1, minWidth: 180,
      renderCell: ({ row }) => describeEventDetail(row.typ, row.val, row.detail) || '-',
    },
  ];

  return (
    <Box>
      <Stack direction="row" spacing={1} sx={{ mb: 1.5 }} flexWrap="wrap" rowGap={1}>
        {TYP_OPTIONS.map((o) => (
          <Chip
            key={o.value || 'ALL'}
            label={o.label}
            size="small"
            color={typFilter === o.value ? 'primary' : 'default'}
            variant={typFilter === o.value ? 'filled' : 'outlined'}
            onClick={() => onTypFilterChange(o.value)}
          />
        ))}
      </Stack>

      <DataGrid
        rows={list}
        columns={columns}
        getRowId={(row) => row.eventId}
        loading={loading}
        autoHeight
        disableColumnMenu
        paginationMode="server"
        rowCount={total}
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={onPageChange}
        pageSizeOptions={[pageSize]}
      />
    </Box>
  );
};

export default EqpEventListPanel;
